import {AutoMap} from '@automapper/classes';
import {
  TBaseBulkDeleteResponseDto,
  TBaseCreateResponseDto,
  TBaseDeleteResponseDto, TBaseGetAllResponseDto, TBaseGetResponseDto, TBaseUpdateResponseDto
} from './common/t-base-response.dto';
import {ReminderLogStatusEnum} from '../enums/reminder-log-status.enum';
import {
  TBaseBulkDeleteRequestDto,
  TBaseCreateRequestDto, TBaseDeleteRequestDto,
  TBaseGetAllRequestDto,
  TBaseGetRequestDto,
  TBaseUpdateRequestDto
} from './common/t-base-request.dto';
import {ReminderLogHighlightGetResponseDto} from './reminder-log-highlight.dto';
import {ReminderLogReadStatusEnum} from '../enums/reminder-log-read-status.enum';

export class ReminderLogGetAllRequestDto extends TBaseGetAllRequestDto {
}

export class ReminderLogGetAllResponseDto extends TBaseGetAllResponseDto {
  @AutoMap()
  public title!: string;

  @AutoMap()
  public sentOn: Date | null = null;

  @AutoMap()
  public status!: ReminderLogStatusEnum;

  @AutoMap()
  public readStatus!: ReminderLogReadStatusEnum;

  @AutoMap()
  public readOn: Date | null = null;
}

export class ReminderLogGetRequestDto extends TBaseGetRequestDto {
}

export class ReminderLogGetResponseDto extends TBaseGetResponseDto {
  @AutoMap()
  public title!: string;

  @AutoMap()
  public sentOn: Date | null = null;

  @AutoMap()
  public status!: ReminderLogStatusEnum;

  @AutoMap()
  public readStatus!: ReminderLogReadStatusEnum;

  @AutoMap()
  public readOn: Date | null = null;

  @AutoMap()
  public errorMessage!: string | null;

  @AutoMap()
  public reminderLogHighlights!: ReminderLogHighlightGetResponseDto[] | null;
}

export class ReminderLogCreateRequestDto extends TBaseCreateRequestDto {
}

export class ReminderLogCreateResponseDto extends TBaseCreateResponseDto {
}

export class ReminderLogUpdateRequestDto extends TBaseUpdateRequestDto {
}

export class ReminderLogUpdateResponseDto extends TBaseUpdateResponseDto {
}

export class ReminderLogDeleteRequestDto extends TBaseDeleteRequestDto {
}

export class ReminderLogDeleteResponseDto extends TBaseDeleteResponseDto {
}

export class ReminderLogBulkDeleteRequestDto extends TBaseBulkDeleteRequestDto {}
export class ReminderLogBulkDeleteResponseDto extends TBaseBulkDeleteResponseDto {}

